module.exports = __webpack_public_path__ + "img/m1.b1552fcd.jpeg";